import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getPatientInitials',
})
export class GetFormInitialsPipe implements PipeTransform {
  transform(patientArr, id) {
    const temp = patientArr.filter((patient) => patient.id === id.id);
    return temp.length ? temp[0] : null;
  }
}
